<template>
  <section class="content">
    <div>
      <div class="box-body">
        <div class="sorting1">
          <div class="col-md-8">
            <select class="form-control" @change="fiteredResultGA" v-model="regionValue">
              <option value="all">All GA</option>
              <option v-for="(item, index) in journey_managers" :key="index" :value="item.key">
                {{ item.value }}
              </option>
            </select>
          </div>
          <div class="col-md-4 clear_button">
            <button class="inline" @click="clearStatusGA">Clear</button>
          </div>
        </div>

        <div :class="addButtonClass" v-if="this.user.roleName == 'Admin'">
          <router-link :to="{ name: 'VehicleCreate' }">
            <button class="btn">Add New</button>
          </router-link>
        </div>
        <div class="export-btn">
          <button class=" btn gradientbt" v-on:click="exportData">
            Export Vehicle
          </button>
        </div>
        <v-server-table ref="vehicleTable" url :columns="columns" :options="options" v-on:row-click="edit"
          @loaded="onLoaded">
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
        </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import { authService, filterService, vehicleService } from '../../../services';
import axios from 'axios';
import Config from '../../../config';

export default {
  name: 'Vehicle',
  data() {
    return {
      regionManagersIdList: [],
      regionValue: 'all',
      parameters: '',
      journey_managers: [],
      USER_ROLES: USER_ROLES,
      loading: null,
      vehicleTable: null,
      regionData: '',
      region: {},
      params: {},
      columns: [
        'regNo',
        'capacity',
        'ownerName',
        'transportSupervisorContact',
        'transportSupervisorName',
        'status',
      ],
      options: {
        highlightMatches: true,
        sortable: [
          'regNo',
          'capacity',
          'ownerName',
          'transportSupervisorContact',
          'transportSupervisorName',
          'status',
        ],
        headings: {
          regNo: 'Registration No',
          capacity: 'Capacity (WL)',
          ownerName: 'Transporter Name',
          transportSupervisorContact: 'Transport Supervisor Contact',
          transportSupervisorName: 'Transport Supervisor Name',
          status: 'Status',
        },

        templates: {
          status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },
        },
        requestFunction: request => {
          const params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (this.user.roleName == 'GA Head') {
            params.regionRegionManager = this.user._id;
          }
          if (this.regionManagersIdList.length !== 0) {
            params.region = this.regionManagersIdList;
          }
          if (request.orderBy) {
            params.$sort = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          }
          if (request.query) {
            params.$term = request.query;
          } else {
            delete params.$term;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          if (this.parameters != '') {
            params.region = this.parameters;
          }
          this.loading = true;
          return this.$vehicleDataRepository.list(params).catch(error => {
            console.error('Vehicle.requestFunction-error:', error);
            this.$snotify.error('Get Vehicle', 'Error!');
          });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total,
          };
        },
        uniqueKey: '_id',
      },
    };
  },
  mounted: function () {
    this.getGeographicalAreas();
  },
  created() {
    let regionDetails = this.$store.state.auth.userRegion.regionDetails;
    console.log('re', regionDetails);
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(item => item._id);
    }
  },
  computed: {
    addButtonClass() {
      if (this.vehicleTable) {
        return this.vehicleTable.count > this.vehicleTable.limit ||
          this.vehicleTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
    ...mapState({
      user: state => state.auth.user,
    }),
  },
  methods: {
    edit(data) {
      this.$router.push({
        name: 'VehicleDetail',
        params: { _id: data.row._id },
        props: data.row,
      });

    },
    clearStatusGA() {
      this.parameters = ''
      this.regionValue = 'all';
      this.$refs.vehicleTable.refresh();
    },
    fiteredResultGA(e) {
      if (e.target.value === 'all') {
        this.parameters = ''
        this.regionValue = 'all';
      } else {
        this.parameters = e.target.value;
      }
      this.$refs.vehicleTable.refresh();
    },

    getGeographicalAreas() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      let journeyManagerList = [];

      this.$regionsDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            if (this.user.roleName === 'Admin') {
              journeyManagerList = res.data.docs.map(item => {
                return {
                  key: item._id,
                  value: item.name,
                };
              });
              this.journey_managers = journeyManagerList;
            } else {
              journeyManagerList = res.data.docs.map(item => {
                if (this.regionManagersIdList.includes(item._id)) {
                  this.journey_managers.push({
                    key: item._id,
                    value: item.name,
                  });
                }
              });
            }
          }
        })
        .catch(error => {
          this.loading = false;
          console.error('journey Manager.requestFunction-error:', error);
          this.$snotify.error('Get journey manager list failed', 'Error!');
        });
    },
    /*download master data */
    exportData() {
      axios({
        method: 'get',
        url: `${Config.serverURI}/v1/exportMaster?model=vehicle`,
        responseType: 'arraybuffer',
      })
        .then(response => {
          console.log('response of download', response);
          const arrayBuffer = response.data;
          const filename = 'Vehicle.xlsx';
          this.downloadFileFromArrayBuffer(arrayBuffer, filename);
        })
        .catch(err => {
          console.log('err', err);
        });
    },
    /*download file */
    downloadFileFromArrayBuffer(arrayBuffer, filename) {
      const url = URL.createObjectURL(
        new Blob([arrayBuffer], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    onLoaded() {
      this.vehicleTable = this.$refs.vehicleTable;
    },
  },
};
</script>
<style scoped>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 200px;
}

.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.btn {
  background-image: linear-gradient(to right,
      rgba(38, 153, 251),
      rgba(146, 205, 255));
  color: white;
}

.sorting1 {
  position: absolute;
  left: 500px;
  z-index: 1000;
  width: 350px;
  margin-left: 100px;
}

.clear_button button {
  background-color: rgba(255, 132, 78);
  color: white;
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  border-radius: 3px;
  box-shadow: none;
  border: 1px solid transparent;
}
</style>



// WEBPACK FOOTER //
// Vehicles.vue?2c12db9e